import { AccessTokenStatus } from '@/enums';
import { Consts } from '@/consts';

export class AccessTokenInfo {
	public static parse(data: IAccessTokenInfo | null): AccessTokenInfo {
		const accessTokenInfo = new AccessTokenInfo();
		if ((data !== undefined) && (data === null)) {
			return accessTokenInfo;
		}
		if (data.token !== undefined) {
			accessTokenInfo.token = data.token;
		}
		if (data.status !== undefined) {
			accessTokenInfo.status = data.status;
		}
		if ((data.expiresOn !== undefined) && (data.expiresOn !== null)) {
			accessTokenInfo.expiresOn = new Date(data.expiresOn);
		}
		return accessTokenInfo;
	}

	public token: string;
	public status: AccessTokenStatus;
	public expiresOn: Date | null;

	constructor(
		token: string = Consts.EMPTY_STRING,
		status: AccessTokenStatus = AccessTokenStatus.Unknown,
		expiresOn: Date | null = null) {
		this.token = token;
		this.status = status;
		this.expiresOn = expiresOn;
	}

	public isExpired(): boolean {
		if ((this.token === Consts.EMPTY_STRING) || (this.expiresOn === null) || (this.expiresOn <= new Date())) {
			this.status = AccessTokenStatus.Expired;
			return true;
		}
		return false;
	}
}

export interface IAccessTokenInfo {
	token?: string;
	status?: AccessTokenStatus;
	expiresOn?: string;
}
